import React from 'react';
import { Link } from 'react-router-dom';
import { ChartNoAxesCombined, HeartPulse, ClipboardX, Logs } from 'lucide-react';

const PatientActionPopup = ({ isOpen, currentPatient, popupPosition, onClose, onDischargeClick, popupRef, discharge = true }) => {
  if (!isOpen || !currentPatient) return null;

  return (
    <div
      ref={popupRef}
      className="fixed bg-white rounded-xl shadow-2xl border border-gray-100 z-50 min-w-64 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200"
      style={{
        top: `${popupPosition.top}px`,
        left: `${popupPosition.left}px`,
        maxHeight: 'calc(100vh - 20px)',
        top: `clamp(10px, ${popupPosition.top}px, calc(100vh - 320px))`,
        left: `clamp(10px, ${popupPosition.left}px, calc(100vw - 220px))`,
      }}
    >
      <div className="px-4 py-3 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-100">
        <h3 className="text-sm font-semibold text-gray-800">Patient Actions</h3>
        <p className="text-xs text-gray-600 mt-1">{currentPatient.name || 'Current Patient'}</p>
      </div>
      <div className="">
        {/* {discharge && (
          <Link
            to={`/dashboard/ecg/${currentPatient.hospitalId}/${currentPatient.patientId}/${currentPatient.bedNumber}`}
            className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 group"
            onClick={onClose}
          >
            <div className="flex items-center justify-center w-8 h-8 bg-green-100 rounded-lg mr-3 group-hover:bg-green-200 transition-colors">
              <HeartPulse className="h-4 w-4 text-green-600" />
            </div>
            <div className="flex-1">
              <div className="font-medium">View ECG</div>
              <div className="text-xs text-gray-500">Monitor heart activity</div>
            </div>
          </Link>
        )} */}
        {/* {console.log(`/dashboard/trends/${currentPatient.hospitalId}/${currentPatient.bedNumber}`)} */}

        <Link
          to={`/dashboard/trends/${currentPatient.hospitalId}/${currentPatient.patientId}/${currentPatient.bedNumber}`}
          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-150 group"
          onClick={onClose}
        >
          <div className="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-lg mr-3 group-hover:bg-blue-200 transition-colors">
            <ChartNoAxesCombined className="h-4 w-4 text-blue-600" />
          </div>
          <div className="flex-1">
            <div className="font-medium">View Trends</div>
            <div className="text-xs text-gray-500">Analyze patient data</div>
          </div>
        </Link>


        <Link
          to={`/logs/${currentPatient.hospitalId}/${currentPatient.patientId}/${currentPatient.bedNumber}`}
          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-700 transition-colors duration-150 group"
          onClick={onClose}
        >
          <div className="flex items-center justify-center w-8 h-8 bg-yellow-100 rounded-lg mr-3 group-hover:bg-yellow-200 transition-colors">
            <Logs className="h-4 w-4 text-yellow-600" />
          </div>
          <div className="flex-1">
            <div className="font-medium">Event Logs</div>
            <div className="text-xs text-gray-500">View event logs</div>
          </div>
        </Link>

        {/* 
        <Link
          to={`/trends`}
          className="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-150 group"
          onClick={onClose}
        >
          <div className="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-lg mr-3 group-hover:bg-blue-200 transition-colors">
            <ChartNoAxesCombined className="h-4 w-4 text-blue-600" />
          </div>
          <div className="flex-1">
            <div className="font-medium">View Trends</div>
            <div className="text-xs text-gray-500">Analyze patient data</div>
          </div>
        </Link> */}
        {discharge && (
          <div className="border-t border-gray-100">
            <button
              onClick={() => {
                onClose();
                onDischargeClick(currentPatient);
              }}
              className="flex items-center px-4 py-3 text-sm text-red-700 hover:bg-red-50 hover:text-red-800 transition-colors duration-150 group w-full text-left"
            >
              <div className="flex items-center justify-center w-8 h-8 bg-red-100 rounded-lg mr-3 group-hover:bg-red-200 transition-colors">
                <ClipboardX className="h-4 w-4 text-red-600" />
              </div>
              <div className="flex-1">
                <div className="font-medium">Discharge Patient</div>
                <div className="text-xs text-red-500">Complete treatment</div>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PatientActionPopup;